import { render, staticRenderFns } from "./ComputerAdd.vue?vue&type=template&id=2608d9bb"
import script from "./ComputerAdd.vue?vue&type=script&lang=js"
export * from "./ComputerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports